import React from "react";
import styled from "styled-components";
import { useFilterContext } from "../context/FilterProvider";
import { SingleVideo } from "../SingleVideo/SingleVideo";
import StyledList from "./ListVideos-styles";
import SyncLoader from "react-spinners/SyncLoader";

export const ListVideos = () => {
	const [state, dispatch] = useFilterContext();
	const { filter } = state;
	const showThumbs = document.getElementById("show-thumbs");

	return (
		<div>
			{filter && (
				<>
					{filter.length > 0 ? (
						<StyledList className="list-wrapper">
							{filter.map((video) => {
								return <SingleVideo video={video} key={video.id} showThumbs={showThumbs} />;
							})}
						</StyledList>
					) : (
						<StyledSyncLoader>
							<SyncLoader color={"#8865AB"} loading={true} size={20} margin={5} />
						</StyledSyncLoader>
					)}
				</>
			)}
		</div>
	);
};

const StyledSyncLoader = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 200px 0;
	width: 100%;
`;
